import CodeGroup from './src/codeGroup.vue'

export default CodeGroup
